import { Button, Col, Form } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { useForm } from 'react-hook-form';
import { ReactComponent as FacebookSVG } from '../../../../../assets/login/f.svg';
import { ReactComponent as GoogleSVG } from '../../../../../assets/login/G.svg';
import { genericHandlerError } from '../../../../../services/commonServices';

interface LoginProps {
  changeToForgotPassword: Function;
  changeToSignUp: Function;
  onFacebookSubmit: Function;
  onGoogleSubmit: Function;
  username?: string;
  hideSignInModal: Function;
}

function Login({ changeToForgotPassword, changeToSignUp, onFacebookSubmit, onGoogleSubmit, username, hideSignInModal }: LoginProps) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  // const onLogin = (data: any) => signIn(data);
  async function signIn(data: any) {
    try {
      await Auth.signIn(data.username, data.password);
    } catch (error) {
      genericHandlerError(error);
      console.log('error signing in', error);
    }
  }

  return (
    <>
      <Col xs={12} lg={6} className="p-3 px-5 gray-background-sign">
        <div>
          <button className="close" onClick={() => hideSignInModal()}>
            &times;
          </button>
        </div>
        <div className="sign-up-header">Log In</div>
        <div>
          <Form onSubmit={handleSubmit(signIn)}>
            <Form.Row>
              <Form.Group as={Col} controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={username}
                  {...register('username', {
                    required: 'Email required'
                  })}
                />
                {errors.email && (
                  <Form.Text id="emailHelpBlock" muted>
                    {errors.email.message || 'Required'}
                  </Form.Text>
                )}
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  {...register('password', {
                    required: 'Email required'
                  })}
                />
              </Form.Group>
            </Form.Row>

            <Form.Row className="remember-forgot">
              <div className="form-group form-check label checkbox-xl">
                <input type="checkbox" className="form-check-input check" id="exampleCheck1" />
                <label className="form-check-label label-text remember-password" htmlFor="exampleCheck1">
                  Remember Password
                </label>
              </div>
              <Form.Text id="log-in-link">
                <span onClick={() => changeToForgotPassword()} className="text-blue">
                  Forgot Password?
                </span>
              </Form.Text>
            </Form.Row>

            <Button variant="dark" type="submit" className="login-button">
              Log In
            </Button>

            <Form.Row className="center-content p-3">
              <Form.Text id="log-in-link">
                Don't have an account?{' '}
                <span className="underline pointer text-blue" onClick={() => changeToSignUp()}>
                  Sign Up
                </span>
              </Form.Text>
            </Form.Row>

            <Form.Row className="pb-5 d-flex federation-buttons">
              <Button onClick={() => onFacebookSubmit()} className="facebook-button">
                <FacebookSVG className="facebook-button-icon" />
                <span>Facebook</span>
              </Button>
              <Button onClick={() => onGoogleSubmit()} className="google-button">
                <GoogleSVG className="google-button-icon" />
                <span className={'google-span'}>Google</span>
              </Button>
            </Form.Row>
          </Form>
        </div>
      </Col>
      <Col xs={0} lg={6} className="d-none d-lg-block login-right-side p-0">
        <div className="login-right-side-diagonal">
          <div className="montserrat-18 p-2">ARE YOU NEW HERE?</div>
          <div className="montserrat-45 p-2">Be Urbain.</div>
          {/*<div className="lato-25 text-align-center p-2">Enjoy 10% off your first booking.</div> //Commented for the MVP */}
          <Button variant="primary" type="button" className="sign-up-button" onClick={() => changeToSignUp()}>
            Sign Up
          </Button>
        </div>
      </Col>
    </>
  );
}

export default Login;
